const actions = {
  SET_STATE: 'messages/SET_STATE',
  GET_MESSAGE_LOGS: 'messages/GET_MESSAGE_LOGS',
  GET_MESSAGE_CATEGORIES: 'messages/GET_MESSAGE_CATEGORIES',
  GET_GROUP_MESSAGE_LOGS: 'messages/GET_GROUP_MESSAGE_LOGS',
  GET_MOD_MESSAGE_LOGS: 'messages/GET_MOD_MESSAGE_LOGS',
  DELETE_MESSAGE_LOG: 'messages/DELETE_MESSAGE_LOG',
  APPROVE_MOD_MESSAGE: 'messages/APPROVE_MOD_MESSAGE',
  REJECT_MOD_MESSAGE: 'messages/REJECT_MOD_MESSAGE',
  DELETE_GROUP_MESSAGE_LOG: 'messages/DELETE_GROUP_MESSAGE_LOG',
  GET_MESSAGE_SEARCH_LOGS: 'messages/GET_MESSAGE_SEARCH_LOGS',
  GET_MESSAGE_EXPORT_LOGS: 'messages/GET_MESSAGE_EXPORT_LOGS',
  GET_MESSAGE_BY_ID: 'messages/GET_MESSAGE_BY_ID',
}

export default actions
